import React, { useEffect, useRef, useState } from 'react';
import '../css/productHero.css';
import '../css/productSection.css';
import '../css/productContact.css';
import "../css/productSm.css"
import '../css/productRoundIconButton.css'
import SectionTitle from '../../../../component-module/component-services/title/section/ts/sectionTitle';
import HeroContent from '../../../../component-module/component-services/title/hero/ts/heroContent';
import SwitchContentButton from '../../../../component-module/component-services/button/switch-round-button/ts/switchContentButton';
import RoundIconButton from '../../../../component-module/component-services/button/round-button/ts/roundIconButton';
import DynamicContactCard from '../../../../component-module/component-services/card/contact/ts/dynamicContactCard';
import { useNavigate } from 'react-router-dom';
import { useCmsPage } from '../../../../context-module/context-configuration/auth-provider/appShell/appShellContent/appUseCntData';
import { API_ENDPOINTS } from '../../../../context-module/context-configuration/auth-provider/apiGroup/apiProvider';
import { ProductPageData } from './productData';

const contactRouteMap: Record<number, string> = {
  1: '/contact/business-contact',
  2: '/contact/sales-contact',
};

export const mapContactCardsFromCMS = (
  lists: any[] = [],
  navigate?: (path: string) => void
) => {
  return lists?.map((item) => ({
    id: item?.id,
    icon: item?.imgIco,
    iconAlt: item?.imgAlt,
    title: item?.title,
    paragraph: item?.description,
    buttonText: item?.buttonLabel,
    onButtonClick: () => navigate?.(contactRouteMap[item.id]),
  }));
};

function Product() {
  const { data } = useCmsPage<ProductPageData>(API_ENDPOINTS.ROUTE_URL.PRODUCT);
  const [activeCategoryId, setActiveCategoryId] = useState<number | null>(
    data?.product?.cta?.[0]?.productSection?.lists?.[0]?.id ?? null
  );

  const navigate = useNavigate();
  const learnMore = useRef<HTMLDivElement | null>(null);

  const productPageData = data?.product?.cta?.[0]
  const prodHeroSection = productPageData?.heroSection
  const prodContact = productPageData?.contactSection
  const prodSection = productPageData?.productSection

  const contactCards = mapContactCardsFromCMS(prodContact?.lists, navigate);


  useEffect(() => {
    const firstId = prodSection?.lists?.[0]?.id ?? null;
    if (activeCategoryId === null && firstId !== null) {
      setActiveCategoryId(firstId);
    }
  }, [prodSection?.lists, activeCategoryId]);

  const handleCategoryChange = (activeId: number | string | null) => {
    if (activeId === null) return;
    setActiveCategoryId(Number(activeId));
  };

  const onClickLearnMore = () => {
    learnMore.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  const serviceItems = (prodSection?.lists ?? []).map((item) => ({
    id: item.id,
    title: item.title ?? '',
    description: item.description ?? '',
  }));

  const activeList = (prodSection?.lists ?? []).find(
    (x) => x.id === activeCategoryId
  );

  const roundOptions = (activeList?.items ?? []).map((it: any) => ({
    id: it.id,
    label: it.label ?? '',
    icon: it.Icon ?? '',
    iconAlt: it?.iconAlt ?? ''
  }));

  return (
    <>
      <section className="scl--web-page-product-hero-section-box" >
        <div className='scl--web-page-product-hero-section'>
          <div className="scl--web-page-product-hero-section-container">
            {prodHeroSection?.visible &&
              <HeroContent
                titleLine1={prodHeroSection?.title}
                buttonText={prodHeroSection?.primaryButton?.label}
                buttonIconPosition="right"
                onButtonClick={onClickLearnMore}
                btnVisible={prodHeroSection?.primaryButton?.visible}
              />
            }
          </div>
        </div>
        <div className="scl--web-page-product-hero-bg-effect">
          <div className="scl--web-page-product-hero-bg-gradient" />
        </div>
      </section>

      {prodSection?.visible &&
        <section className="scl--web-page-product-section-box" ref={learnMore}>
          <div className="scl--web-page-product-section">
            <div className="scl--web-page-product-section-container">
              <div className="scl--web-page-product-section-inner">
                <div className="scl--web-page-product-service-side">
                  <SectionTitle
                    label={prodSection?.label}
                    title={prodSection?.title}
                    description={prodSection?.description}
                    className="scl--web-page-product-styled-section-title"
                  />

                  <div className="scl--web-page-product-service-list">
                    <SwitchContentButton
                      items={serviceItems}
                      defaultActiveId={prodSection?.lists?.[0]?.id ?? null}
                      onChange={handleCategoryChange}
                    />
                  </div>
                </div>

                <div className="scl--web-page-product-image-side">
                  {(prodSection?.lists ?? /* istanbul ignore next */[]).map((item) => {
                    return (
                      <img
                        key={item?.id}
                        src={item?.img}
                        alt={item?.imgAlt ?? item.title ?? ''}
                        className={`scl--web-page-product-content-image ${activeCategoryId === item.id ? 'active' : ''
                          }`}
                      />
                    )
                  })}

                  <RoundIconButton
                    key={activeCategoryId ?? 'none'}
                    className="scl--web-page-product-image-icon-button"
                    options={roundOptions}
                  />

                </div>
              </div>
            </div>
          </div>

        </section>
      }


      {prodContact?.visible &&
        <section className="scl--web-page-product-contact-section-box">
          <div className="scl--web-page-product-contact-section">
            <div className="scl--web-page-product-contact-section-lap">
              <div className="scl--web-page-product-contact-top">
                <div className="scl--web-page-product-contact-top-left">
                  <div className="scl--web-page-product-contact-label">
                    <div className="scl--web-page-product-contact-label-bracket-left" />
                    <span className="scl--web-page-product-contact-label-text">{prodContact?.label}</span>
                    <div className="scl--web-page-product-contact-label-bracket-right" />
                  </div>
                  <h1 className="scl--web-page-product-contact-title">
                    {prodContact?.title}
                  </h1>
                </div>
                <p className="scl--web-page-product-contact-description">
                  {prodContact?.description}
                </p>
              </div>
              <div className="scl--web-page-product-contact-section-container">

                <div className={`scl--web-page-product-contact-cards ${contactCards.length >= 3 ? 'scl--web-page-product-contact-cards-grid' : ''}`}>
                  {contactCards?.map((card) => {
                    return (
                      <div key={card.id} className="scl--web-page-product-contact-card-wrapper">
                        <DynamicContactCard
                          iconAlt={card?.iconAlt}
                          icon={card?.icon}
                          title={card.title}
                          description={card.paragraph}
                          buttonText={card.buttonText}
                          onButtonClick={card.onButtonClick}
                        />
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>


        </section>
      }

    </>
  );
}

export default Product;
